// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: "Montserrat", sans-serif; 
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
   overflow-x: hidden;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* background-image: linear-gradient(90deg, #ffffff, #ffffff, #7aa6ffca); */
  background-image: linear-gradient(90deg, #ffffff, #ffffff, #f8f0f0);
  /* background: white; */
  color: #333;

}

h1 {
  font-family: "Montserrat", sans-serif; 
    font-optical-sizing: auto;
    font-weight: 600;
}

h2 {
  font-family: "Montserrat", sans-serif; 
  font-optical-sizing: auto;
  font-weight: 600;
}

h3 {
  font-family: "Montserrat", sans-serif; 
  font-optical-sizing: auto;
  font-weight: 600;
}

ul {
  /* list-style-type: "✔"; */
  list-style-type: none;
}

li {
  display: list-item;
  text-align: -webkit-match-parent;
  unicode-bidi: isolate;
}

a {
  text-decoration: none;
}

textarea {
  transition: 0.3s all;
  outline: none;
  border: 1px solid #ccc;
}

textarea:focus {
  transition: 0.3s all;
  border-color: #4985FF;
}

p {
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  unicode-bidi: isolate;
  margin: 0;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,qCAAqC;EACrC,mCAAmC;EACnC,kCAAkC;GACjC,kBAAkB;EACnB,mCAAmC;EACnC,kCAAkC;EAClC,2EAA2E;EAC3E,mEAAmE;EACnE,uBAAuB;EACvB,WAAW;;AAEb;;AAEA;EACE,qCAAqC;IACnC,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE;aACW;AACb","sourcesContent":["body {\n  margin: 0;\n  font-family: \"Montserrat\", sans-serif; \n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n   overflow-x: hidden;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  /* background-image: linear-gradient(90deg, #ffffff, #ffffff, #7aa6ffca); */\n  background-image: linear-gradient(90deg, #ffffff, #ffffff, #f8f0f0);\n  /* background: white; */\n  color: #333;\n\n}\n\nh1 {\n  font-family: \"Montserrat\", sans-serif; \n    font-optical-sizing: auto;\n    font-weight: 600;\n}\n\nh2 {\n  font-family: \"Montserrat\", sans-serif; \n  font-optical-sizing: auto;\n  font-weight: 600;\n}\n\nh3 {\n  font-family: \"Montserrat\", sans-serif; \n  font-optical-sizing: auto;\n  font-weight: 600;\n}\n\nul {\n  /* list-style-type: \"✔\"; */\n  list-style-type: none;\n}\n\nli {\n  display: list-item;\n  text-align: -webkit-match-parent;\n  unicode-bidi: isolate;\n}\n\na {\n  text-decoration: none;\n}\n\ntextarea {\n  transition: 0.3s all;\n  outline: none;\n  border: 1px solid #ccc;\n}\n\ntextarea:focus {\n  transition: 0.3s all;\n  border-color: #4985FF;\n}\n\np {\n  display: block;\n  margin-block-start: 1em;\n  margin-block-end: 1em;\n  margin-inline-start: 0px;\n  margin-inline-end: 0px;\n  unicode-bidi: isolate;\n  margin: 0;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
